import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore/lite";

export const app = initializeApp({
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
});

export const db = getFirestore(app);
export const ADMIN_EMAIL = process.env.REACT_APP_ADMIN_EMAIL;
export const DEFAULT_QR_BASE_URL = process.env.REACT_APP_DEFAULT_QR_BASE_URL;
